import { useEffect, useRef } from "react";
import { base44 } from "@/api/base44Client";

export function useSessionTimer() {
  const sessionStartRef = useRef(Date.now());
  const lastSaveRef = useRef(Date.now());
  const timerIntervalRef = useRef(null);

  useEffect(() => {
    // Reset session start when component mounts
    sessionStartRef.current = Date.now();
    lastSaveRef.current = Date.now();

    // Save session time every 5 minutes
    timerIntervalRef.current = setInterval(async () => {
      const now = Date.now();
      const sessionDuration = Math.floor((now - lastSaveRef.current) / 1000); // in seconds

      if (sessionDuration > 0) {
        const isAuthenticated = await base44.auth.isAuthenticated();
        if (!isAuthenticated) return;

        base44.functions.invoke("updateUserSessionTime", {
          duration_seconds: sessionDuration,
        }).catch(() => {});
        lastSaveRef.current = now;
      }
    }, 5 * 60 * 1000); // 5 minutes

    return () => {
      if (timerIntervalRef.current) {
        clearInterval(timerIntervalRef.current);
      }
    };
  }, []);
}